// src/pages/admin/AdminReservations.js
// Gestion des réservations (admin) - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ROUTES from '../../constants/routes';
import {
  RESERVATION_STATUS,
  RESERVATION_STATUS_LABELS,
  RESERVATION_STATUS_COLORS,
} from '../../constants/reservationStatus';

const AdminReservations = () => {
  const navigate = useNavigate();
  const [reservations, setReservations] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    // Données de démo (à remplacer par adminReservationsAPI.getAll())
    const demoReservations = [
      {
        id: 101,
        clientName: 'Jean Kamga',
        clientPhone: '+237690000001',
        listingTitle: 'Appartement moderne meublé',
        quartier: 'Bonapriso',
        checkInDate: '2026-07-15',
        checkOutDate: '2026-08-15',
        numberOfGuests: 2,
        message: 'Bonjour, disponible pour visite cette semaine ?',
        ownerPhone: '+237640460565',
        status: 'new',
        createdAt: '2026-07-01',
      },
      {
        id: 102,
        clientName: 'Marie Ndongo',
        clientPhone: '+237690000002',
        listingTitle: 'Studio meublé centre-ville',
        quartier: 'Akwa',
        checkInDate: '2026-07-10',
        checkOutDate: '2026-07-12',
        numberOfGuests: 1,
        message: '',
        ownerPhone: '+237640460565',
        status: 'contacted',
        createdAt: '2026-06-30',
      },
      {
        id: 103,
        clientName: 'Paul Fotso',
        clientPhone: '+237690000003',
        listingTitle: 'Villa de luxe avec piscine',
        quartier: 'Bastos',
        checkInDate: '2026-08-01',
        checkOutDate: '2026-09-01',
        numberOfGuests: 5,
        message: 'Intéressé pour location longue durée',
        ownerPhone: '+237640460565',
        status: 'confirmed',
        createdAt: '2026-06-28',
      },
    ];
    setReservations(demoReservations);
  }, []);

  const statusFilters = [
    { id: 'all', label: 'Toutes' },
    { id: 'new', label: 'Nouvelles' },
    { id: 'contacted', label: 'Contactées' },
    { id: 'confirmed', label: 'Confirmées' },
    { id: 'cancelled', label: 'Annulées' },
  ];

  const filteredReservations = reservations.filter(
    (r) => filter === 'all' || r.status === filter
  );

  const handleStatusChange = (reservationId, newStatus) => {
    // TODO: adminReservationsAPI.updateStatus(reservationId, newStatus)
    setReservations((prev) =>
      prev.map((r) => (r.id === reservationId ? { ...r, status: newStatus } : r))
    );
  };

  const handleContactClient = (phone, listingTitle) => {
    const message = encodeURIComponent(`Bonjour, concernant votre demande pour "${listingTitle}" sur Fynho...`);
    const cleanPhone = phone.replace(/\D/g, '');
    window.open(`https://wa.me/${cleanPhone}?text=${message}`, '_blank');
  };

  const handleContactOwner = (phone, clientName, listingTitle) => {
    const message = encodeURIComponent(`Bonjour, nous avons une demande de ${clientName} pour "${listingTitle}".`);
    const cleanPhone = phone.replace(/\D/g, '');
    window.open(`https://wa.me/${cleanPhone}?text=${message}`, '_blank');
  };

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      maxWidth: '900px',
      margin: '0 auto',
      backgroundColor: '#0A0E1A',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px 20px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
    },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    filters: {
      display: 'flex',
      gap: '8px',
      overflowX: 'auto',
      padding: '16px 20px',
      scrollbarWidth: 'none',
    },
    filterBtn: {
      padding: '8px 14px',
      borderRadius: '20px',
      backgroundColor: '#162033',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      color: '#A0AEC0',
      fontSize: '13px',
      fontWeight: '600',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    },
    filterBtnActive: {
      backgroundColor: 'rgba(255, 215, 0, 0.15)',
      border: '1px solid rgba(255, 215, 0, 0.3)',
      color: '#FFD700',
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      padding: '0 20px 40px',
    },
    card: {
      padding: '16px',
      backgroundColor: '#162033',
      borderRadius: '12px',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
    cardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    clientName: { fontSize: '16px', fontWeight: '600', color: '#FFFFFF' },
    statusBadge: {
      padding: '3px 10px',
      borderRadius: '12px',
      fontSize: '11px',
      fontWeight: '600',
    },
    infoRow: { fontSize: '13px', color: '#A0AEC0', display: 'flex', gap: '6px' },
    infoLabel: { color: '#4A5568' },
    message: {
      fontSize: '13px',
      color: '#A0AEC0',
      fontStyle: 'italic',
      padding: '8px 12px',
      backgroundColor: '#111827',
      borderRadius: '8px',
      lineHeight: '1.4',
    },
    actions: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      marginTop: '4px',
    },
    actionBtn: {
      padding: '8px 12px',
      borderRadius: '8px',
      border: 'none',
      fontSize: '12px',
      fontWeight: '600',
      cursor: 'pointer',
    },
    whatsappClient: { backgroundColor: 'rgba(72, 187, 120, 0.15)', color: '#48BB78' },
    whatsappOwner: { backgroundColor: 'rgba(66, 153, 225, 0.15)', color: '#4299E1' },
    confirmBtn: { backgroundColor: 'rgba(255, 215, 0, 0.15)', color: '#FFD700' },
    cancelBtn: { backgroundColor: 'rgba(245, 101, 101, 0.15)', color: '#F56565' },
    empty: {
      textAlign: 'center',
      padding: '48px',
      color: '#A0AEC0',
      fontSize: '14px',
    },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Gestion des réservations | Fynho Admin</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(ROUTES.ADMIN_DASHBOARD)}>←</button>
        <div style={styles.title}>Réservations</div>
      </div>

      <div style={styles.filters} className="hide-scrollbar">
        <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; }`}</style>
        {statusFilters.map((f) => (
          <button
            key={f.id}
            style={{
              ...styles.filterBtn,
              ...(filter === f.id ? styles.filterBtnActive : {}),
            }}
            onClick={() => setFilter(f.id)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div style={styles.list}>
        {filteredReservations.length === 0 ? (
          <div style={styles.empty}>Aucune réservation</div>
        ) : (
          filteredReservations.map((res) => (
            <div key={res.id} style={styles.card}>
              <div style={styles.cardHeader}>
                <div style={styles.clientName}>{res.clientName}</div>
                <span
                  style={{
                    ...styles.statusBadge,
                    backgroundColor: `${RESERVATION_STATUS_COLORS[res.status]}22`,
                    color: RESERVATION_STATUS_COLORS[res.status],
                  }}
                >
                  {RESERVATION_STATUS_LABELS[res.status]}
                </span>
              </div>

              <div style={styles.infoRow}>
                <span style={styles.infoLabel}>🏡</span> {res.listingTitle} ({res.quartier})
              </div>
              <div style={styles.infoRow}>
                <span style={styles.infoLabel}>📞</span> {res.clientPhone}
              </div>
              <div style={styles.infoRow}>
                <span style={styles.infoLabel}>📅</span> {res.checkInDate}
                {res.checkOutDate ? ` → ${res.checkOutDate}` : ''}
                {res.numberOfGuests ? ` · ${res.numberOfGuests} pers.` : ''}
              </div>

              {res.message && <div style={styles.message}>"{res.message}"</div>}

              <div style={styles.actions}>
                <button
                  style={{ ...styles.actionBtn, ...styles.whatsappClient }}
                  onClick={() => {
                    handleContactClient(res.clientPhone, res.listingTitle);
                    handleStatusChange(res.id, RESERVATION_STATUS.CONTACTED);
                  }}
                >
                  💬 Client
                </button>
                <button
                  style={{ ...styles.actionBtn, ...styles.whatsappOwner }}
                  onClick={() => handleContactOwner(res.ownerPhone, res.clientName, res.listingTitle)}
                >
                  💬 Propriétaire
                </button>
                {res.status !== 'confirmed' && (
                  <button
                    style={{ ...styles.actionBtn, ...styles.confirmBtn }}
                    onClick={() => handleStatusChange(res.id, RESERVATION_STATUS.CONFIRMED)}
                  >
                    ✓ Confirmer
                  </button>
                )}
                {res.status !== 'cancelled' && (
                  <button
                    style={{ ...styles.actionBtn, ...styles.cancelBtn }}
                    onClick={() => handleStatusChange(res.id, RESERVATION_STATUS.CANCELLED)}
                  >
                    ✕ Annuler
                  </button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminReservations;